import app from './feathers'
// import { mediaStore } from '../stores/mediaStore'
import { activeMediaStore } from '../stores/activeMediaStore'

const hypeTrainService = app.service('hypetrain')

hypeTrainService.on('start-train', (data) => {
    if (!data.level) return false
    activeMediaStore.update(data)
})

const methods = {
    async send(data) {
        return await hypeTrainService.create(data)
    },
    async testEvent(data) {
        return await hypeTrainService.create(data)
    },
}

export default methods
